type PayoutStatus = 'paid' | 'pending' | 'in_transit' | 'failed' | 'canceled';

const STYLES: Record<PayoutStatus, { bg: string; color: string; border: string }> = {
  paid: { bg: 'rgba(16,185,129,0.1)', color: '', border: '' },
  pending: { bg: 'rgba(245,158,11,0.1)', color: '', border: '' },
  in_transit: { bg: 'rgba(59,130,246,0.1)', color: '', border: '' },
  failed: { bg: 'rgba(239,68,68,0.1)', color: '', border: '' },
  canceled: { bg: 'var(--dash-hover-bg)', color: 'var(--dash-text-muted)', border: 'var(--dash-border)' },
};

const ACCENT_CLASSES: Partial<Record<PayoutStatus, string>> = {
  paid: 'text-emerald-400 border-emerald-500/30',
  pending: 'text-amber-400 border-amber-500/30',
  in_transit: 'text-blue-400 border-blue-500/30',
  failed: 'text-red-400 border-red-500/30',
};

const LABELS: Record<PayoutStatus, string> = {
  paid: 'Paid',
  pending: 'Pending',
  in_transit: 'In Transit',
  failed: 'Failed',
  canceled: 'Canceled',
};

export default function PayoutStatusBadge({ status }: { status: string }) {
  const key = status as PayoutStatus;
  const style = STYLES[key] || STYLES.pending;
  const label = LABELS[key] || status.replace(/_/g, ' ');
  const accentClass = ACCENT_CLASSES[key];

  if (accentClass) {
    return (
      <span
        className={`inline-block px-2 py-0.5 text-xs font-mono font-medium border rounded ${accentClass}`}
        style={{ background: style.bg }}
      >
        {label}
      </span>
    );
  }

  return (
    <span
      className="inline-block px-2 py-0.5 text-xs font-mono font-medium rounded"
      style={{
        background: style.bg,
        color: style.color,
        border: `1px solid ${style.border}`,
      }}
    >
      {label}
    </span>
  );
}
